// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Ef2a_w0ekpQa1UrTS_df{flex-direction:column;flex-grow:1;gap:16px;margin:24px 20px 5px;display:flex}.jKZNOTWXqi4YqaQ_HMI_{flex-grow:1;height:530px;display:flex}.U9_yl1W4A9QW6ZBMwjc3{justify-content:center;align-items:center;min-height:200px;padding:20px;display:flex}.azezt1B5gY3d_5b1yWE7{display:flex}.nPvjBToiXFQyVv5mrd9A{opacity:.5}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"creditUsageTable": `Ef2a_w0ekpQa1UrTS_df`,
	"tableContainer": `jKZNOTWXqi4YqaQ_HMI_`,
	"emptyState": `U9_yl1W4A9QW6ZBMwjc3`,
	"chatbotName": `azezt1B5gY3d_5b1yWE7`,
	"disabledStatus": `nPvjBToiXFQyVv5mrd9A`
};
export default ___CSS_LOADER_EXPORT___;
